import { createAction } from '@reduxjs/toolkit';

export const wsConnect = createAction('@@websocket/CONNECT');
export const wsConnected = createAction('@@websocket/CONNECTED');
export const wsDisconnect = createAction('@@websocket/DISCONNECT');
export const wsDisconnected = createAction('@@websocket/DISCONNECTED');
export const wsReceiveMessage = createAction('@@websocket/RECEIVE_MESSAGE');
export const wsResetMessage = createAction('@@websocket/RESET_MESSAGE');
